// eslint-disable import/no-anonymous-default-export
export default {
  dev: {
    API: {
      // baseURL: "https://devhubopsapis.innofulfill.com/smcs-webapp",
      // bffBaseURL: "https://devhubopsapis.innofulfill.com",
      bulkBaseURL: "https://smcs-dev.hutechweb.com/bulk-booking",
      baseURL: "https://smcs-dev.hutechweb.com/smcs-webapp",
      bffBaseURL: "https://smcs-dev.hutechweb.com",
      baseURLInnofulfill: "https://bookingapis.innofulfill.com",
      hubopsBaseURL: "https://devhubopsapis.innofulfill.com/smcs-webapp",
      hubopsRootURL: "https://devhubopsapis.innofulfill.com",
      tatURL: "https://devapis.delcaper.com/routemaster/hubEstimate",
      delcaperBaseURL: "https://devapis.delcaper.com",
      delcaperBaseURLv2: "https://devapis2.delcaper.com",
      baseURLDispatch: "https://devdispatchapis.delcaper.com",
      reportGustTokenURL:
        "https://qaapis.hubops.innofulfill.com/datazip/fetch-guest-token",
      drsScanExeURL:
        "https://drs-scan-exe-release.s3.ap-south-1.amazonaws.com/releases/DRS+Scan+Setup+1.0.8.exe",
      trackingURL: "https://qatracking.shreemaruti.com",
    },
    auth: {
      domain: "smcs-prod.hutechweb.com",
      oauthDomain: "SMCS_POOL.auth.us-east-1.amazoncognito.com",
      userPoolWebClientId: "5764umttfqiplob9e337ar0v0m",
      userPoolId: "us-east-1_TD8m0Yrs9",
      region: "us-east-1",
      datazip_userName: "datazip.embed",
      datazip_password: "JNF0D*fa$cd4",
    },
  },
  qa: {
    API: {
      //baseURL: "https://qaapis.hubops.innofulfill.com/smcs-webapp",
      bulkBaseURL: "https://sandbox.api.bookings.innofulfill.com/bulk-booking",
      baseURL: "https://sandbox.api.bookings.innofulfill.com/smcs-webapp",
      bffBaseURL: "https://sandbox.api.bookings.innofulfill.com",
      baseURLInnofulfill: "https://sandbox.bookingapis.innofulfill.com",
      hubopsBaseURL: "https://qaapis.hubops.innofulfill.com/smcs-webapp",
      hubopsRootURL: "https://qaapis.hubops.innofulfill.com",
      tatURL: "https://qaapis.delcaper.com/routemaster/hubEstimate",
      delcaperBaseURL: "https://qaapis.delcaper.com",
      delcaperBaseURLv2: "https://qaapis2.delcaper.com",
      baseURLDispatch: "https://qadispatchapis.delcaper.com",
      reportGustTokenURL:
        "https://qaapis.hubops.innofulfill.com/datazip/fetch-guest-token",
      drsScanExeURL:
        "https://drs-scan-exe-release.s3.ap-south-1.amazonaws.com/releases/DRS+Scan+Setup+1.0.8.exe",
      trackingURL: "https://qatracking.shreemaruti.com",
    },
    auth: {
      domain: "qaapis.hubops.innofulfill.com",
      oauthDomain: "smcs.auth.ap-south-1.amazoncognito.com",
      userPoolWebClientId: "a3e0iaciccfeln7no5b467ab5",
      userPoolId: "ap-south-1_xoRMaTXJu",
      region: "ap-south-1",
      datazip_userName: "datazip.embed",
      datazip_password: "JNF0D*fa$cd4",
    },
  },
  uat: {
    API: {
      bulkBaseURL: "https://sandbox.api.bookings.innofulfill.com/bulk-booking",
      baseURL: "https://uatapis-hubops.innofulfill.com/smcs-webapp",
      bffBaseURL: "https://uatapis-hubops.innofulfill.com",
      baseURLInnofulfill: "https://bookingapis.innofulfill.com",
      hubopsRootURL: "https://uatapis-hubops.innofulfill.com",
      tatURL: "https://qaapis.delcaper.com/routemaster/hubEstimate",
      reportGustTokenURL:
        "https://qaapis.hubops.innofulfill.com/datazip/fetch-guest-token",
      drsScanExeURL:
        "https://drs-scan-exe-release.s3.ap-south-1.amazonaws.com/releases/DRS+Scan+Setup+1.0.8.exe",
      trackingURL: "https://qatracking.shreemaruti.com",
    },
    auth: {
      domain: "smcs-uat.hutechweb.com",
      oauthDomain: "smcs.auth.ap-south-1.amazoncognito.com",
      userPoolWebClientId: "a3e0iaciccfeln7no5b467ab5",
      userPoolId: "ap-south-1_xoRMaTXJu",
      region: "ap-south-1",
      datazip_userName: "datazip.embed",
      datazip_password: "JNF0D*fa$cd4",
    },
  },
  prod: {
    API: {
      bulkBaseURL: "https://apis.bookings.innofulfill.com/bulk-booking",
      baseURL: "https://apis.bookings.innofulfill.com/smcs-webapp",
      bffBaseURL: "https://apis.bookings.innofulfill.com",
      baseURLInnofulfill: "https://bookingapis.innofulfill.com",
      hubopsBaseURL: "https://apis-hubops.innofulfill.com/smcs-webapp",
      hubopsRootURL: "https://apis-hubops.innofulfill.com",
      tatURL: "https://apis.delcaper.com/routemaster/hubEstimate",
      delcaperBaseURL: "https://apis.delcaper.com",
      delcaperBaseURLv2: "https://apis2.delcaper.com",
      baseURLDispatch: "https://dispatchapis.delcaper.com",
      reportGustTokenURL:
        "https://apis-hubops.innofulfill.com/datazip/fetch-guest-token",
      drsScanExeURL:
        "https://drs-scan-exe-release.s3.ap-south-1.amazonaws.com/releases/DRS+Scan+Setup+1.0.8.exe",
      trackingURL: "https://tracking.shreemaruti.com",
    },
    auth: {
      domain: "smcs-prod.hutechweb.com",
      oauthDomain: "smcs.auth.ap-south-1.amazoncognito.com",
      userPoolWebClientId: "4q270kj0hhe1jimi5tbopv2vts",
      userPoolId: "ap-south-1_7Q0AtPCUn",
      region: "ap-south-1",
      datazip_userName: "datazip.embed",
      datazip_password: "JNF0D*fa$cd4",
    },
  },
};
